module.exports = {
      id: "daily-crossword-usage",
      viewBox: "0 0 220 220",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#daily-crossword",
      toString: function () {
        return this.url;
      }
    }